import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import AddedIconSvg from "./added.svg";
import PlusIconSvg from "./plus-icon.svg";

export const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TopicItem = styled.div<{ $followed: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  padding-block: 10px;
  padding-inline: 16px;

  border: 1px solid #bbbbbb;

  ${theme.breakpoints.only("mobile")} {
    &:nth-of-type(n + 4) {
      display: none;
    }
  }

  ${theme.breakpoints.up("desktop")} {
    &:nth-of-type(n + 7) {
      display: none;
    }
  }

  ${props =>
    props.$followed &&
    `
    background-color: #FFCA05;
  `}
`;

export const TopicLeft = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  align-items: flex-start;
`;

export const TopicTag = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
`;

export const TopicName = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
`;

export const TopicRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledPlusIcon = styled(PlusIconSvg)`
  display: block;

  cursor: pointer;
`;

export const StyledAddedIcon = styled(AddedIconSvg)`
  display: block;

  cursor: pointer;
`;

export const ShowMoreButton = styled.label`
  margin-block-start: 16px;

  color: #4585ff;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  text-align: center;

  background: none;

  cursor: pointer;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const ShowMoreButtonBox = styled.input`
  display: none;

  ${theme.breakpoints.only("mobile")} {
    &:checked ~ ${TopicItem}:nth-of-type(n + 4) {
      display: flex;
    }
  }

  &:checked ~ ${ShowMoreButton} {
    display: none;
  }
`;
